import { render, staticRenderFns } from "./DemandInfo.vue?vue&type=template&id=ed80cf42&scoped=true&"
import script from "./DemandInfo.vue?vue&type=script&lang=js&"
export * from "./DemandInfo.vue?vue&type=script&lang=js&"
import style0 from "./DemandInfo.vue?vue&type=style&index=0&id=ed80cf42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed80cf42",
  null
  
)

export default component.exports